import React from "react";
import { Flex } from "../../components/Flex";
import { UserBookingsScreen } from "./Bookings";
import { UserMessagesScreen } from "./Messages";
import { useTranslation } from "react-i18next";
var SignoutWithHeading = function (props) {
    return React.createElement(Flex, { className: "ws-entity-header ws-entity-" + props.entity + "-header" },
        React.createElement("h2", null, props.label));
};
export var SummaryScreen = (function () {
    var t = useTranslation().t;
    return (React.createElement(Flex, { isInline: false, className: "ws-summary-entity-wrapper" },
        React.createElement("div", { className: "ws-summary-entity ws-summary-entity-bookings" },
            React.createElement(UserBookingsScreen, { heading: React.createElement(SignoutWithHeading, { entity: "bookings", label: t("user_entity.tabs.bookings") }) })),
        React.createElement("div", { className: "ws-summary-entity ws-summary-entity-messages" },
            React.createElement(UserMessagesScreen, { heading: React.createElement(SignoutWithHeading, { entity: "messages", label: t("user_entity.tabs.messages") }) }))));
});
